module.exports = __webpack_public_path__ + "mq.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/mq.svg
// module id = 701
// module chunks = 0